export enum NotificationType {
    TrackandTraceSearchPage,
    APInvoiceDetailsPage,
    EstimatePage,
    LeaseDetailsPage,
    ProgramworkPage,
    ServiceEventDetailsPage,
    AuditPage,
    RailincFiles,
    FreightApPageReady,
    FreightApPageApproved,
    ProgramworkSearch,
    CarHireSearchPage,
    BaseRentalReport,
    StorageApPageReady,
    StorageApPageApproved,
    RailcarSearchPage,
    ShopPortalReviewPage
}
